import React, { Suspense } from 'react';
import { componentTypes } from '@white-nl/instantsearch-components';
import { Newspaper } from "@/js/react/src/components/ui/icons/classic/regular";
import IconRegistry from '../../ui/icons/IconRegistry';

export default function Menu(
  {
    menu,
    menuSettings,
    results,
    additionalData,
  }: componentTypes.MenuProps,
) {
  const {
    items,
    refine,
    createURL,
  } = menu;

  const {
    classNames,
  } = menuSettings;

  const {
    categoriesLabels,
    categoriesIcons,
    showAllLabel,
  } = additionalData;

  // eslint-disable-next-line no-underscore-dangle
  if (results.__isArtificial) {
    return null;
  }

  let isRefined = false;
  const totalCount = results.nbHits;
  if (items.length > 0){
    Object.values(items).forEach((item) => {
      // @ts-ignore
      if (item.isRefined) isRefined = true;
    });
  }

  const { eye: Eye } = IconRegistry;

  return (
    <div className={`ais-Menu-root ${classNames?.root ?? ''}`}>
      <ul className={`ais-Menu-list ${classNames?.list ?? ''}`}>
        <li className={`ais-Menu-item ${classNames?.item ?? ''}${!isRefined ? ` ais-Menu-item--selected ${classNames?.selectedItem ?? ''}` : ''}`}>
          <a
            href={createURL('')}
            onClick={(event) => {
              event.preventDefault();
              refine('');
            }}
            className={`ais-Menu-link ${classNames?.link ?? ''}`}
          >
            <Suspense fallback={<Newspaper iconClass="ais-Menu-icon h-4.5 w-auto mr-3 grow-0" />}>
              <Eye iconClass="ais-Menu-icon h-4.5 w-auto mr-3 grow-0" />
            </Suspense>
            <span className={`ais-Menu-label ${classNames?.label ?? ''}`}>{showAllLabel}</span>
            <span className={`ais-Menu-count ${classNames?.count ?? ''}`}>({totalCount})</span>
          </a>
        </li>
        {items.map((item) => {
          const iconHandle = categoriesIcons?.[item.label];
          const ItemIcon = iconHandle && iconHandle in IconRegistry
            ? (IconRegistry[iconHandle as keyof typeof IconRegistry] as React.ComponentType<any>)
            : null;

          return (
            <li
              key={item.value}
              className={`ais-Menu-item ${classNames?.item ?? ''}${item.isRefined ? ` ais-Menu-item--selected ${classNames?.selectedItem ?? ''}` : ''}`}
            >
              <a
                className={`ais-Menu-link ${classNames?.link ?? ''}`}
                href={createURL(item.value)}
                onClick={(event) => {
                  event.preventDefault();
                  refine(item.value);
                }}
              >
                {ItemIcon && (
                  <Suspense fallback={<Newspaper iconClass="ais-Menu-icon h-4.5 w-auto mr-3 grow-0" />}>
                    {React.createElement(ItemIcon, { iconClass: 'ais-Menu-icon h-4.5 w-auto mr-3 grow-0' })}
                  </Suspense>
                )}
                <span className={`ais-Menu-label ${classNames?.label ?? ''}`}>
                  {categoriesLabels ? (categoriesLabels[item.label] ?? item.label) : item.label}
                </span>
                <span className={`ais-Menu-count ${classNames?.count ?? ''}`}>
                  ({item.count})
                </span>
              </a>
            </li>
          );
        })}
      </ul>
    </div>

  );
}
